export type CheckpointTypeFilterType = {
  key?: string;
  status?: string;
  type?: string;
};

export enum CheckPointLocalStorage {
  IS_FROM_MUTATION = 'isFromCheckPointMutation',
  KEY = 'checkPointFilterKey',
  STATUS = 'checkPointFilterStatus',
  TYPE = 'checkPointFilterType',
}
